import { render, staticRenderFns } from "./GlobalModalController.vue?vue&type=template&id=be88bb18&scoped=true&"
import script from "./GlobalModalController.vue?vue&type=script&lang=js&"
export * from "./GlobalModalController.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be88bb18",
  null
  
)

export default component.exports